<template>


        <div
          class="connectingflight"
          v-if="ticketDetail"
          >
          <div class="f_card" v-for="(flightObj,index) in ticketDetail" :key="'g'+index">
            <div class="flight_info" v-if="flightObj.flight">
              <div class="flight_d" v-if="ticketingDetail.airlines">
                <div class="icon">
                  <img
                    v-if="flightObj.flight.opAirline"
                    :src="ticketingDetail.airlines[flightObj.flight.opAirline].logourl"
                    :onerror="defaultALImg"
                    width="40px"
                  />
                </div>
                <div class="text">
                  <div>{{flightObj.flight.FlightNo}}</div>
                  <span class="d-flex">
                    {{ticketingDetail.airlines[flightObj.flight.opAirline].airline_name +' '
                    }} |
                    <span
                      class="ml-5px d-flex"
                    >
                      <div>{{flightObj.flight.DepAirport+' - '+flightObj.flight.ArrAirport}}</div>
                    </span>
                  </span>
                </div>
              </div>
              <div class="class-des">
                <!-- <div
                  v-if="ticketingDetail.journeyType==3"
                >{{$t("cTicketingDetail.leg")+' '+(index+1)}}</div>
                <div
                  v-else
                >{{flightObj.id.includes("_IB")?$t("cTicketingDetail.departure"):$t("cTicketingDetail.return")}}</div> -->
                <span>Class {{flightObj.flight.Bookingclass}}</span>
              </div>
            </div>
            <div class="flight_t_info" v-if="flightObj.flight">
              <div class="text-right">
                <span
                  v-if="flightObj.flight.DepDate"
                >{{flightObj.flight.DepDate|formatDate}}</span>
                <div
                  class="time"
                  v-if="flightObj.flight.DepDate"
                >{{flightObj.flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}</div>
                <span
                  v-if="flightObj.flight.DepAirport"
                >{{ticketingDetail.airports[flightObj.flight.DepAirport].airportname}}</span>
              </div>
              <div class="f_icon">
                <img src="~@imgPath/img/svg/icons/flight-black.svg" alt />
              </div>

              <div class="text-left" v-if="flightObj.flight.ArrDate">
                <span>{{flightObj.flight.ArrDate|formatDate}}</span>
                <div
                  class="time"
                  v-if="flightObj.flight.ArrDate"
                >{{flightObj.flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}</div>
                <span
                  v-if="flightObj.flight.ArrAirport"
                >{{ticketingDetail.airports[flightObj.flight.ArrAirport].airportname}}</span>
              </div>
            </div>
          </div>
        </div>
      
</template>

<script>
import {
  COMPONENT_NAME,
  PATHNAME,
  TRIP,
  DEFAULT_DROPDOWN_STATUS,
  ALERT_MODAL_STATUS,
  BOOKING_STATUS,DATE_TIME_FORMAT,
  ORDER
} from "../../util/constants";
import {
  cloneData,
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  GroupByList,
  OrderBy,
  OrderByList
} from "../../util/util";
import BaseConfiguration from "../../config/base";
import Logger from "../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";

export default {
  name: COMPONENT_NAME.C_TICKETING_CONNECTION_FLIGHT,

  props: {
    ticketDetail: {
      type: Array | Object,
      default: null
    },
    ticketingDetail:  {
      type: Array | Object,
      default: null
    }
  },

  data() {
    return {
      defaultALImg: BaseConfiguration.defaultALImg,
    };
  },
  
  computed:{
      DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          }

  },
  // watch: {
  //   ticketDetail(val) {
  //     if (val) {
  //       this.ticketingDetail = cloneData(val);
  //     }
  //   }
  // },

  methods: {
   
    
  },

  created() {
    if (BaseConfiguration.isDebug) console.log("created");
    
  }
};
</script>
<style scoped>
.connectingflight {
    width: 50%;
}
</style>